import styles from '@features/layout/components/SectionTitle/SectionTitle.styles';
import Heading from '@components/Heading/Heading';
type PropsType = {
  title: string;
};
const SectionTitle = ({
  title
}: PropsType) => <div sx={styles.titleContainer} data-cy="SectionTitle">
    <Heading headingType={2} mobile>
      {title}
    </Heading>
  </div>;
export default SectionTitle;